export const violationTypes = [
  { value: "double_park", label: "Double park" },
  { value: "bike_lane", label: "Bike lane" },
  { value: "no_stopping", label: "No stopping" },
  { value: "unregistered_vehicle", label: "Unregistered Vehicle" },
  { value: "unpermitted_vehicle", label: "Unpermitted Vehicle" },
  { value: "exceeds_max_time", label: "Dwell time" },
  { value: "warning_max_time", label: "Max time warning" },
  { value: "bus_stop", label: "Bus stop" },
  { value: "unpaid_invoice", label: "Unpaid invoice" },
];

const violationTypeLabelsByValue = violationTypes.reduce((acc, violationType) => {
  acc[violationType.value] = violationType.label;
  return acc;
}, {} as Record<string, string>);

export const getViolationTypeLabel = (violationType: string, accountId?: string): string => {
  const isObstructingTrafficAccount =
    !!accountId &&
    (accountId === process.env.REACT_APP_MPA_ACCOUNT_ID || accountId === process.env.REACT_APP_MBPA_ACCOUNT_ID);
  if (isObstructingTrafficAccount && violationType === "double_park") {
    return "Obstructing Traffic";
  }
  return violationTypeLabelsByValue[violationType] || violationType;
};

export const getViolationTypeOptions = (
  accountId?: string,
  applicableViolationTypes?: string[],
): { value: string; label: string }[] => {
  const options = applicableViolationTypes
    ? violationTypes.filter(({ value }) => applicableViolationTypes.includes(value))
    : violationTypes;
  return options.map(({ value }) => ({ value, label: getViolationTypeLabel(value, accountId) }));
};
